var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"rounded":"","color":"white"}},[(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":""}}):(!_vm.node.icon)?_c('span',{style:(`font-weight: bold; font-size: 25px; color: ${
      _vm.isDark ? 'white' : 'black'
    }`)},[_vm._v(_vm._s(_vm.node.displayName[0]))]):(
      _vm.node.icon && (_vm.node.icon.startsWith('fa') || _vm.node.icon.startsWith('mdi'))
    )?_c('v-icon',{attrs:{"large":"","color":_vm.isDark ? 'white' : 'black'}},[_vm._v(" "+_vm._s(_vm.node.icon)+" ")]):_c('v-img',{attrs:{"src":_vm.apiURL(`/node-icon/${_vm.node.name}`)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }